import axiosInstance from "../../translator";
import { resellerLicense } from "../../constants/apis/apiEndpoints";

export const fetchResellerLicenseList = async (urlParams) => {
  return axiosInstance
    .get(`${resellerLicense?.licenceList}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchResellerLicenseCustomerView = async () => {
  return axiosInstance
    .get(`${resellerLicense?.licenseStats}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteLicenseApi = async (id) => {
  return axiosInstance
    .delete(`${resellerLicense?.licenceList}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const updateLicenseApi = async (id, data) => {
  return axiosInstance
    .put(`${resellerLicense?.licenceList}/${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
export const createResellerLicense = async (data) => {
  return axiosInstance
    .post(`${resellerLicense?.licenceList}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getRlicenseDetailsByID = async (id) => {
  return axiosInstance
    .get(`${resellerLicense?.licenceList}/${id}`)
    .then((response) => {
      return {
        data: response?.data,
        status: response?.status,
      };
    })
    .catch((error) => {
      return error;
    });
};

export const fetchlicenseSummary = async (id) => {
  return axiosInstance
    .get(`${resellerLicense?.licenceList}/${id}`)
    .then((response) => {
      return {
        data: response?.data,
        status: response?.status,
      };
    })
    .catch((error) => {
      return error;
    });
};
